import React from 'react'
import WidgetLayout from '../../components/layouts/WidgetLayout'
import ReactTable from 'react-table'
import numeral from 'numeral'
import URL from 'url-parse'
import { graphql } from 'gatsby'
import 'react-table/react-table.css'

const LEFT_COLUMN_STYLE =  {
  whiteSpace: 'unset',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

const RIGHT_COLUMN_STYLE =  {
  whiteSpace: 'unset',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  textAlign: 'right',
}


class StateGamblingPage extends React.Component {

  _formatBigNumber = props => <>{numeral(props.value).format('0.0a')}</>

  _formatNumber = props => {
    let value
    if (props.original.state !== 'pa') {
      value = numeral(props.value).format('0,0')
    } else {
      value = 'n/a'
    }
    return <>{value}</>
  }

  render() {
    const qs = (typeof window !== 'undefined') ? new URL(window.location.href, true).query : {hideMeta: true}
    const { configYaml, allGoogleSheetStatesRow } = this.props.data
    const data = allGoogleSheetStatesRow.edges.map( d => d.node )

    return (<WidgetLayout config={configYaml}>
      <div>
        {(!qs.hideMeta) ? (<div className="pg-main page-meta-header">
          <h1>States Where Video Gambling Is Legal Outside of Casinos</h1>
        </div>) : null}
      </div>
      <ReactTable
        data={data}
        defaultPageSize={data.length}
        showPagination={false}
        showPageSizeOptions={false}
        sortable={false}
        getTrProps={ (state, rowInfo, column) => {
          return {
            style: {
              background: rowInfo.original.state === 'il' ? "#FFEFC9" : "none"
            }
          }
        }}
        columns={[
          {
            Header: 'State',
            accessor: 'stateName',
            style: LEFT_COLUMN_STYLE,
            width: 150,
            Cell: props => {
              const { original } = props
              const className = `stateface stateface-${original.state}`
              return <div className="state-col"><span className={className} /><span className="state-name">{props.value}</span></div>
            },
          },
          {
            Header: 'Population',
            accessor: 'population',
            style: RIGHT_COLUMN_STYLE,
            Cell: this._formatBigNumber,
          },
          {
            Header: 'Machines',
            accessor: 'machines',
            style: RIGHT_COLUMN_STYLE,
            Cell: this._formatNumber,
          },
          {
            Header: 'Locations',
            accessor: 'locations',
            style: RIGHT_COLUMN_STYLE,
            Cell: this._formatNumber,
          },
          {
            Header: 'Tax Rate',
            accessor: 'taxRate',
            minWidth: 200,
            style: RIGHT_COLUMN_STYLE,
            Cell: props => (
              <div dangerouslySetInnerHTML={{__html: props.value}} />
            ),
          },

        ]}
      />

      <div>
        {(!qs.hideMeta) ? (<div className="pg-main page-meta-footer">
          <p>Notes: Data on the number and location of machines in Pennsylvania is not yet available because the state only recently legalized them and no machines had gone live at the time of publication.</p>
          <p>Data Source: State gaming agencies, 2018; U.S. Census Bureau, 2017</p>
          <p>Credit: David Eads/ProPublica Illinois</p>
        </div>) : null}
      </div>
    </WidgetLayout>)
  }
}

export default StateGamblingPage

export const query = graphql`
  query StateGamblingQuery {
    allGoogleSheetStatesRow {
      edges {
        node {
          state
          stateName
          population
          machines
          locations
          taxRate
        }
      }
    }
    configYaml {
      description
      title
      meta {
        name
        content
        http_equiv
      }
    }
  }
`
